import { CSP_NONCE, Directive, inject } from '@angular/core';

@Directive({
  selector: '[libCspNonce]',
  host: {
    '[attr.ngCspNonce]': 'nonce',
  },
})
export class CspNonce {
  protected readonly nonce = inject(CSP_NONCE, { optional: true });
}
